// extracted by mini-css-extract-plugin
module.exports = {"dashboards":"style_dashboards__eNdYB","header":"style_header__qE513","printOnly":"style_printOnly__3rUk7","printOnly_wrapper":"style_printOnly_wrapper__1oGZ7"};